import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';

interface CustomEventProps {
  event: {
    title: string;
    start: Date;
  };
}

export const CustomEvent = React.memo<CustomEventProps>(({ event }) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      p: 0.5,
      '&:hover': {
        opacity: 0.9
      }
    }}
  >
    <Typography
      variant="caption"
      sx={{
        opacity: 0.9,
        fontWeight: 500,
        mb: 0.5
      }}
    >
      {format(event.start, 'h:mm a')}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        lineHeight: 1.2,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {event.title}
    </Typography>
  </Box>
));